export default function ($scope, $timeout, $mdDialog, Restangular, FlashService, progression, subscriptions, users, $filter) {

    $scope.selected = [];
    $scope.users = [];
    $scope.is_company = HasRole('company');

    $scope.subscriptions = subscriptions;

    users.forEach(function(u, ui){
        u.subscription_state = 'inactive';
        u.subscriptions_use = 0;

        subscriptions.forEach(function(s, si){
            if(s.user && u.id == s.user.id){
                u.subscription_state = 'active';
                u.subscription_expirated = s.finalize;
                u.subscriptions_use++;
            }

        });

        $scope.users.push(u);
    });


    $scope.addSubscription = function($event, user){
        let translate = $filter('translate');

        let confirm = $mdDialog.prompt()
            .title(translate('ADD_SUBSCRIPTION_TITLE'))
            .htmlContent(translate('ADD_SUBSCRIPTION_CONTENT'))
            .placeholder(translate('ADD_SUBSCRIPTION_INPUT'))
            .targetEvent($event)
            .ok(translate('ADD_SUBSCRIPTION_BUTTON'))
            .cancel(translate('MODAL_CANCEL'));

        $mdDialog.show(confirm).then(function(total) {
            progression.start();

            return Restangular
                .one("subscription/link")
                .one("user", user.id)
                .patch({_use: total})
                .then(data => {
                    data = data.data ? data.data : data;

                    FlashService.Success("ADD_SUBSCRIPTION_SUCCESS");

                    user.subscription_state = 'active';
                    user.subscription_expirated = data.date;
                    user.subscriptions_use = data.total;

                    progression.done();

                }, error => {
                    error = error.data ? error.data : error;

                    if(error.error == 1000){
                        let alert = $mdDialog.alert()
                            .title(translate('ENOUGH_SUBSCRIPTION_TITLE'))
                            .htmlContent(translate('ENOUGH_SUBSCRIPTION'))
                            .targetEvent($event)
                            .ok(translate('OK'));

                        $mdDialog.show(alert);
                    }
                    else
                        FlashService.Error(error.error_description);

                    progression.done();
                });
        });
    };

    $scope.removeSubscription = function($event, user){
        let translate = $filter('translate');

        let confirm = $mdDialog.confirm()
            .title(translate('REMOVE_SUBSCRIPTION_TITLE'))
            .htmlContent(translate('REMOVE_SUBSCRIPTION_CONTENT'))
            .targetEvent($event)
            .ok(translate('REMOVE_SUBSCRIPTION_BUTTON'))
            .cancel(translate('MODAL_CANCEL'));

        $mdDialog.show(confirm).then(function() {
            progression.start();

            return Restangular
                .one("subscription/unlink")
                .one("user", user.id)
                .patch()
                .then(data => {
                    user.subscription_state = 'inactive';
                    user.subscription_expirated = null;
                    user.subscriptions_use = 0;

                    FlashService.Success("REMOVE_SUBSCRIPTION_SUCCESS");

                    progression.done();

                }, error => {
                    error = error.data ? error.data : error;

                    FlashService.Error(error.error_description);

                    progression.done();
                });


        });
    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/subscriptions/controller.js
 **/